import { DataSubset } from "../ars_ldm";
import { isNamedObject } from "./isNamedObject";
import { isObjectRecord } from "./isObjectRecord";
import { isWhereClause } from "./isWhereClause";

/**
 * Type guard to check if a value is a DataSubset.
 *
 * Validates that the object has the required properties of a DataSubset:
 * - Extends NamedObject (name, description?, label?)
 * - Extends WhereClause (level, order, condition?, compoundExpression?)
 * - Has an id string
 *
 * @param obj - The value to check
 * @returns True if the value is a DataSubset, false otherwise
 */
export const isDataSubset = (obj: unknown): obj is DataSubset => {
  if (!isObjectRecord(obj)) return false;
  // Check NamedObject and WhereClause
  if (!isNamedObject(obj) || !isWhereClause(obj)) return false;
  // Check id
  if (typeof obj.id !== "string") return false;
  // Check uniqueSubjects if present
  if (!["boolean", "undefined"].includes(typeof obj.uniqueSubjects)) return false;
  // Check uniqueDataSet if present
  if (!["string", "undefined"].includes(typeof obj.uniqueDataSet)) return false;
  // Check uniqueVariables if present
  if (
    obj.uniqueVariables !== undefined &&
    !(Array.isArray(obj.uniqueVariables) && obj.uniqueVariables.every((v) => typeof v === "string"))
  )
    return false;
  // Everything is good
  return true;
};
